export default __webpack_public_path__ + "2585c7abaa3ccd85af1004b36a5a2706.svg";